import { render, staticRenderFns } from "./WithdrawDelegationRewardMessageDetails.vue?vue&type=template&id=46a08a7b&"
import script from "./WithdrawDelegationRewardMessageDetails.vue?vue&type=script&lang=js&"
export * from "./WithdrawDelegationRewardMessageDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports